export enum ToastGroup {
  BuildIssueConfiguredItem = 'build-issue-configured-item'
}
